var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-chart"},[_c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.seriesAboveThreshold,"height":_vm.chartHeight,"width":_vm.chartWidth}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }